import { DestroyRef, Renderer2 } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControlDirective } from '@angular/forms';
import { asyncScheduler } from 'rxjs';

import { EnhancedFormControl } from '../form-extensions/generic-form';
import { AnchorDirective } from './dropdown-anchor.directive';

export class ControlClassSync {
  constructor(
    private destroyRef: DestroyRef,
    private renderer: Renderer2,
  ) {}

  sync(anchorRef: AnchorDirective, controlDirective: FormControlDirective) {
    this.syncNgFormClasses(controlDirective, anchorRef.element);
  }

  private syncNgFormClasses(controlDirective: FormControlDirective, anchorHostElement: HTMLElement): void {
    // validation helper that will set validation classes to anchor host
    controlDirective.form.statusChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.assignNgClasses(controlDirective, anchorHostElement);
    });
    if (controlDirective.control instanceof EnhancedFormControl) {
      controlDirective.control.statusChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        asyncScheduler.schedule(() => {
          this.assignNgClasses(controlDirective, anchorHostElement);
        }, 100);
      });
    }
    this.assignNgClasses(controlDirective, anchorHostElement);
  }

  private assignNgClasses(controlDirective: FormControlDirective, anchorHostElement: HTMLElement): void {
    if (controlDirective.invalid) {
      this.renderer.addClass(anchorHostElement, 'ng-invalid');
    } else {
      this.renderer.removeClass(anchorHostElement, 'ng-invalid');
    }
    if (controlDirective.dirty) {
      this.renderer.addClass(anchorHostElement, 'ng-dirty');
    } else {
      this.renderer.removeClass(anchorHostElement, 'ng-dirty');
    }
    if (controlDirective.touched) {
      this.renderer.addClass(anchorHostElement, 'ng-touched');
    } else {
      this.renderer.removeClass(anchorHostElement, 'ng-touched');
    }
  }
}
